export default {
  admin: {
    name: 'Administration',
    permissions: 'Rechte',
    users: 'Benutzer',
    userPermissions: 'Benutzer - Rechte',
  },
  opticheck: {
    name: 'Opticheck',
    tasks: 'Aufgaben',
    import: 'Import',
    optimizations: 'Optimierungen',
    jobs: 'Jobs',
  },
  adwords: {
    name: 'AdWords',
    dashboard: 'Report',
  },
  user: {
    name: 'Benutzer',
    todos: 'ToDo\'s',
  },
}
